import { SYSTEM_LABEL, type System } from "./localLibrary";

/** The console's drawing, small, beside a name; its name on hover when `named`. */
export default function ConsoleIcon({ system, named = false }: { system: System; named?: boolean }) {
  const label = SYSTEM_LABEL[system];
  return <img src={`/consoles/${system}.png`} alt={named ? label : ""} className="console-mark" data-tip={named ? label : undefined} />;
}
